import React from "react";
import NumberFormat from "react-number-format";

function WidgetsMonthReview(props) {
  return (
    <div
      className={`card col-12 col-lg padding-32 ${
        (props.className !== undefined) & (props.className !== null) ? props.className : ""
      }`}
    >
      <span className="title fz-16 ff-univanova-600 text-cl-black">{props.title}</span>
      <span className="value fz-34 ff-univanova-600 text-cl-black">
        <NumberFormat
          thousandSeparator={"."}
          decimalSeparator=","
          displayType={"text"}
          prefix={props.isMoney ? "R$ " : ""}
          value={props.value}
        />
      </span>
      <label className={`description text-cl-arsenic bg-white`}>
        <span className={`percent fz-12 ff-univanova-medium me-2 ${props.percent > 0 ? "green" : "red"}`}>
          {props.percent > 0 ? "+" + props.percent + "%" : props.percent + "%"}
        </span>
        em relação ao último mês
      </label>
    </div>
  );
}

export default WidgetsMonthReview;
